module.exports = __webpack_public_path__ + "static/media/025.f7ba97c2.jpg";